import { config } from "../../utils/constants";
import axios from "axios";
import { getCurrentLocale } from "../../utils/util";

export const getPatientInformation = (emiratesId) => {
  const locale = getCurrentLocale();
  let requestBody = {
    emiratesId: emiratesId,
    locale: locale
  };
  const requestConfig = {
    method: "POST",
    url: `${config.viewMrn}get-info`,
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const verifyOtp = (otp, id, emiratesId) => {
  let requestBody = {
    otp: otp,
    id: id,
    emiratesId: emiratesId
  };
  const requestConfig = {
    method: "POST",
    url: `${config.viewMrn}verify-info`,
    data: requestBody
  };
  return axios.request(requestConfig);
};